<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Waste Consumption</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="wasteData"
    dataKey="Id"
    editMode="row"
    id="WasteConsumptionTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="font-weight: bold; width: 100px;">Months</th>
        <th class="center-table">Hazardous waste (Oily Waste) (M3)</th>
        <th class="center-table">Hazardous waste (Chemical Waste) (M3)</th>
        <th class="center-table">Hazardous waste (Drilling Waste) (M3)</th>
        <th class="center-table">Hazardous waste (Other Waste) (M3)</th>
        <th class="center-table">Non-Hazardous waste (Scrap Metal) (KG)</th>
        <th class="center-table">Non-Hazardous waste (Wood Scrap) (KG)</th>
        <th class="center-table">Non-Hazardous waste (Plastic Scrap) (KG)</th>
        <th class="center-table">Non-Hazardous waste (Domestic / Office) (KG)</th>
        <th class="center-table">Non-Hazardous waste (Kitchen) (KG)</th>
        <th class="center-table">Amount Sewage water (Gallon)</th>
        <th class="center-table">OBM Disposed (M3)</th>
        <th class="center-table">Number of consignment note</th>
        <th style="width: 8rem">Actions</th>
      </tr>
    </ng-template>
    <ng-template
        pTemplate="body"
        let-waste
        let-editing="editing"
        let-ri="rowIndex"
      >
        <tr [pEditableRow]="waste">
          <td style="width: 100px;" [ngStyle]="{'font-weight':waste.category === 'Total' ? 'bold' : 'normal'}">
            {{ waste.category }}
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.HazardousWasteOily"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.HazardousWasteOily }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.HazardousWasteChemical"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.HazardousWasteChemical }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.HazardousWasteDrilling"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.HazardousWasteDrilling }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.HazardousWasteOther"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.HazardousWasteOther }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NonHazardScrap"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NonHazardScrap }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NonHazardWood"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NonHazardWood }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NonHazardPlastic"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NonHazardPlastic }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NonHazardDomestic"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NonHazardDomestic }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NonHazardKitchen"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NonHazardKitchen }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.SewageWater"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.SewageWater }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.OBMDisp"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.OBMDisp }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="number"
                  [(ngModel)]="waste.NumOfConsignmentNote"
                  required
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ waste.NumOfConsignmentNote }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="center-table">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pencil"
              (click)="onRowEditInit(waste)"
              class="p-button-rounded p-button-text"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-check"
              (click)="onRowEditSave(waste, ri)"
              class="p-button-rounded p-button-text p-button-success p-mr-2"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-times"
              (click)="onRowEditCancel(waste, ri)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-template>
  </p-table>
</div>
<!-- 
<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
    
      </div>
      <div class="modal-body">
    
        <ol id="liPDheight">
          <ng-container
            *ngFor="let item of WasteConsumptionData; let i = index"
          >
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="WasteConsumptionData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div> -->
